import { CanDeactivate } from '@angular/router';
import { Injectable, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AlertDialogService } from '../../../services/alertDialog.service';

export interface ComponentCanDeactivate extends OnInit, OnDestroy, AfterViewInit {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private alertDialog: AlertDialogService) { };

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate() ?
      true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      this.alertDialog.openDialog(null, 'Bạn còn dữ liệu chưa hoàn tất, bạn có muốn thoát không?', 'Không', 'Có').onClose.map(result => {
        return result;
      })
      //confirm('WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
  }
}
